import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _size from 'lodash/size';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Models
import mSource from 'models/source';
// Custom
import { deviceSlaveInputDataShape, sourceDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const InputItem = ({ input, initiallyOpen, sources }) => {
  const inputSources = input.sources;
  let icon = 'itemNothing';
  let value = <LocalizedMessage id="info.inputNotLinked" />;
  let nestedSources = null;
  // Display input sources
  const nbSources = _size(inputSources);
  if (!!sources && nbSources > 0) {
    if (nbSources === 1) {
      const source = _find(sources, { id: inputSources[0] });
      icon = mSource.type(source).icon;
      value = <LocalizedMessage id="info.inputLinkedToSource" values={{ source: source.name }} />;
    } else {
      value = <LocalizedMessage id="info.inputLinkedToNbSources" values={{ nbSources }} />;
      nestedSources = _map(inputSources, (sourceId) => {
        const source = _find(sources, { id: sourceId });
        return ({
          key: _toString(source.id),
          icon: mSource.type(source).icon,
          label: <LocalizedMessage id={`source.type.${source.type}`} />,
          value: source.name,
        });
      });
      if (nbSources < 10) {
        icon = `itemMultiple${nbSources}`;
      } else {
        icon = 'itemMultiple9Plus';
      }
    }
  }

  return (
    <InformationItem
      label={<LocalizedMessage id="info.input" values={{ input: input.code }} />}
      value={value}
      icon={icon}
      withAvatar
      initiallyOpen={initiallyOpen}
      nestedItems={nestedSources}
    />
  );
};

InputItem.propTypes = {
  input: deviceSlaveInputDataShape.isRequired,
  initiallyOpen: PropTypes.bool,
  sources: PropTypes.arrayOf(sourceDataShape),
};

InputItem.defaultProps = {
  initiallyOpen: false,
  sources: null,
};

const mapStateToProps = (state) => ({
  sources: state.installationSource.list.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(InputItem);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/InputItem.js